<template>
  <div>
    <table
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; line-height: 1.5;width:100%;"
    >
      <tbody>
        <tr>
          <td>
            <hr style="border-bottom:none;border-top:1px solid #E4E4E4;margin:20px 0;">
          </td>
          <td>
            <hr style="border-bottom:none;border-top:1px solid #E4E4E4;margin:20px 0;">
          </td>
        </tr>
      </tbody>
    </table>
    <table
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; line-height: 1.5"
    >
      <tbody>
        <!-- Avatar column -->
        <tr>
          <td style="vertical-align: top;">
            <table>
                <tbody>
                    <tr>
                        <td>
                            <img
                                style="height:50px;"
                                src="data:image/png;base64,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"
                            >
                        </td>
                        <td>
                            <avatar
                                :show-avatar="showAvatar"
                                :src="image"
                                :size="options.avatar.size"
                                style="margin-left:5px;"
                                :roundness="options.avatar.roundness"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            
            
          </td>
          <!-- Info column -->
          <td style="vertical-align: top;">
            <table
              cellspacing="0"
              cellpadding="0"
              border="0"
              role="presentation"
              style="font-size: 0;"
            >
              <tbody>
                <!-- Name and job fields -->
                <tr>
                  <td>
                    <span
                      style="font-family:Arial;font-size:20px;color:#1B2734"
                    >{{ mainFields[0].value }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span
                      style="font-family: Arial,Helvetica,sans-serif;font-size: 14px;color: #627282;"
                    >
                      {{ mainFields[1].value }}
                    </span>
                  </td>
                </tr>

                <!-- Other fields -->
                <tr>
                  <td>
                    <table
                      cellspacing="0"
                      cellpadding="0"
                      border="0"
                      role="presentation"
                      style="margin-top: 5px; font-size: 0;"
                    >
                      <tr>
                        <td>
                          <span
                            v-for="item in otherFields"
                            :key="item.name"
                          >
                            <span
                              v-if="item.type === 'phone' && item.value"
                              :style="fontBase"
                            >{{ item.value }}<span
                              v-if="item.name=='Phone1'"
                              class="separator"
                              :style="fontBase"
                            >&nbsp; |&nbsp;</span></span>
                          </span>
                        </td>
                      </tr>
                      <template v-for="item in otherFields">
                        <tr
                          v-if="item.value"
                          :key="item.name"
                        >
                          <td>
                            <a
                              v-if="item.type === 'email'"
                              :href="`mailto:${item.value}`"
                              :style="fontLink"
                            >{{ item.value }}</a>
                            <span
                              v-if="item.name === 'Address'"
                              :style="fontBase"
                              v-html="item.value"
                            />
                            <span
                              v-else-if="item.type === 'text'"
                              :style="fontBase"
                            >{{ item.value }}</span>
                          </td>
                        </tr>
                        
                      </template>
                      <tr>
                            <td>
                                <a
                                    v-if="this.basic.marketplace.country"
                                    style="font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#1662C6;line-height: 22px;text-decoration:none;"
                                    :href="marketplaces.marketplaces.filter((key)=>{return key.lang == this.basic.marketplace.country})[0].link"
                                >
                                    {{ marketplaces.marketplaces.filter((key)=>{return key.lang == this.basic.marketplace.country})[0].link.substr(8) }}
                                </a>
                            </td>
                        </tr>
                    </table>
                  </td>
                </tr>
                <!-- Social icons -->
                <tr v-if="socials.installed.length">
                  <td>
                    <table
                      cellspacing="2"
                      cellpadding="0"
                      border="0"
                      role="presentation"
                      style="margin-top: 5px; margin-left: -2px; font-size: 0;"
                    >
                      <tbody>
                        <tr>
                          <td
                            v-for="item in socials.installed"
                            :key="item.name"
                            align="center"
                            style="width: 24px; height: 24px; "
                          >
                            <a :href="formatLink(item.link)">
                              <img
                                width="24px"
                                :src="generateBase64(`${s3url}/icons/${item.icon}.png`)"
                                :alt="`social-icon-${item.icon}`"
                                style="display: table-cell; vertical-align: middle;"
                              >
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Addons -->
    <table
      v-if="isAdded('mobileApp')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="margin-top: 10px; font-size: 0;"
    >
      <tbody>
        <tr>
          <td v-if="addons.mobileApp.appStore.link">
            <a :href="addons.mobileApp.appStore.link">
              <img
                :src="addons.mobileApp.appStore.img"
                style="height:35px; margin-right: 5px;"
                alt="app store badge"
              >
            </a>
          </td>
          <td v-if="addons.mobileApp.googlePlay.link">
            <a :href="addons.mobileApp.googlePlay.link">
              <img
                :src="addons.mobileApp.googlePlay.img"
                style="height:35px;"
                alt="google play badge"
              >
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <table
      v-if="isAdded('banner')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      style="font-size: 0; margin-top: 10px; width: 100%;"
    >
      <tbody>
        <tr v-if="addons.banner.image">
          <td>
            <a
              v-if="addons.banner.link"
              :href="formatLink(addons.banner.link)"
            >
              <img
                :src="addons.banner.image"
                alt="banner"
                style="max-width: 100%"
              >
            </a>
            <img
              v-else
              :src="addons.banner.image"
              alt="banner"
              style="max-width: 100%"
            >
          </td>
        </tr>
        <banner-placeholder v-else />
      </tbody>
    </table>
    <table
      v-if="isAdded('disclaimer')"
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      
    >
      <tbody>
        <tr>
          <td>
            <span 
                style="display:block;margin-top:10px;font-family:Arial, Helvetica, sans-serif;font-size: 12px; color: #98A1AB; line-height:16px; margin-top: 10px;"
            >
                {{ addons.disclaimer }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <table
        v-if="isAdded('custom')"
        cellspacing="0"
        cellpadding="0"
        border="0"
        role="presentation"
        
    >
      <tbody>
        <tr>
          <td>
            <span 
                style="display:block;margin-top:10px;font-family:Arial, Helvetica, sans-serif;font-size: 12px; color: #98A1AB; line-height:16px; margin-top: 10px;"
            >
                {{ addons.custom }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import EmailTemplate from './emailTemplate'
import Avatar from './components/Avatar'
import BannerPlaceholder from './components/BannerPlaceholder'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    Avatar,
    BannerPlaceholder
  },
  extends: EmailTemplate,

  data() {
    return {
      items: {
        type: Array,
        default: undefined
      },
    }
  },

  mounted: function () {
  
  },

  computed: {
    ...mapState(['socials']),
    ...mapGetters({
      socials: 'socials',
      socialsLink: 'socialsLink',
    }),
  },

  watch: {
    socials: {
        handler: function (val, oldVal) { 
          this.getSocialsStates();     
        },
        deep: true
    }
  },

  async created() {
    this.$store.watch((state, getters) => getters.socialsLink,
      (newValue, oldValue) => {
        return;
      })
    this.$store.watch(
      (state, getters) => getters.socials,
      (newValue, oldValue) => {
        this.getSocialsStates();
      },
    );
  },

  methods: {

    getSocialsStates () {
      const socials = this.$store.getters.socials;
      this.items = [];
      let items = [];

      socials.forEach(async (item)=>{
        let prepItem = {};
        prepItem.name = item.name;
        prepItem.link = item.link;

        let awaitedImg = await this.getEncodedSvgBase64(item.icon);
        prepItem.src = awaitedImg;
        prepItem.alt = "social-icon-"+item.icon;

        items.push(prepItem);
      })

      this.items = items;
    },
    getEncodedSvgBase64 (icon) {
      return new Promise(resolve => {
        const url = require("@/assets/image/" + icon + ".png");
        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
          const codes = new Uint8Array(xhr.response);
          const bin = String.fromCharCode.apply(null, codes);
          resolve("data:image/png;base64," + btoa(bin));
        };
        xhr.open('GET', url);
        xhr.responseType = 'arraybuffer';
        xhr.send();
      });
    },
  }
}
</script>
